import reportService from '@/service/reportService'
import lottoService from '@/service/lottoService'

const encode = value => encodeURIComponent(String(value))
const query = values => new URLSearchParams(Object.entries(values).filter(([, v]) => v !== '' && v != null)).toString()

export default {
  context: () => reportService.getAuthen('receiving-report/context'),
  rounds: (huayId, includeRoundId) => reportService.getAuthen(`receiving-report/rounds/${encode(huayId)}?${query({ includeRoundId })}`),
  read: (huayId, roundId, params) => reportService.getAuthen(`receiving-report/${encode(huayId)}/${encode(roundId)}?${query(params)}`),
  history: (huayId, agent) => reportService.getAuthen(`receiving-report/history/${encode(huayId)}?${query({ agent })}`),
  saveCaps: (agent, caps) => lottoService.postAuthen('api/riskcap/bulk', { agent, caps }),
}
